// const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']

// export const parseTime = (timestr) => {
//   let t = timestr.split(":");
//   if (!t[0] || !t[1]) return false;
//   t[0] = t[0].trim();
//   t[1] = t[1].trim()

//   let hours = Number(t[0]);
//   let minutes = Number(t[1].substr(0, 2));
//   let AmPm = t[1].substr(2);
//   if (isNaN(hours) || isNaN(minutes) || (AmPm !== 'AM' && AmPm !== 'PM')) return false;

//   if (AmPm === 'PM') hours = hours + 12;
//   return {
//     hours,
//     minutes
//   }
// }

export const parseDateTimeToString = (startAt, endAt) => {
  const date = startAt.format("ddd, MMM DD,")
  // const month = startAt.format("MMM").toUpperCase();
  // const date = startAt.format("DD");
  // const year = startAt.format("YYYY");
  const startTime = startAt.format("hh:mm a");
  const endTime = endAt.format("hh:mm a");
  let datStr = date + "*" + startTime + " - " + endTime;
  return datStr
}

// const formatTime = (date) => {
//   let h = date.getHours();
//   let m = date.getMinutes();
//   let amPm = "AM";
//   if (h === 12) {
//     amPm = "PM"
//   }
//   if (h > 12) {
//     h = h - 12;
//     amPm = "PM"
//   }
//   if (m < 10) m = "0" + m
//   return h + ":" + m + amPm
// }

// export const parseDateTimeString = (str) => {
//   if (!str) return false
//   let date = str.split(',')[0];
//   if (!date) return false
//   date = date.split(' ');
//   if (date.length !== 3) return false
//   let month = months.indexOf(date[0]);
//   let day = Number(date[1]);
//   let year = Number(date[2]);

//   if (month < 0 || isNaN(day) || isNaN(year) || date[2].length !== 4) return false

//   let time = str.split(',')[1];
//   if (!time) return false
//   time = time.trim().split("-");
//   let startTime = time[0];
//   let endTime = time[1];
//   if (!startTime || !endTime) return false
//   startTime = parseTime(startTime);
//   endTime = parseTime(endTime);
//   if (!startTime || !endTime) return false
//   let startDateTime = new Date(year, month, day, startTime.hours, startTime.minutes);
//   let endDateTime = new Date(year, month, day, endTime.hours, endTime.minutes);
//   if (startDateTime.getTime() > endDateTime.getTime()) return false
//   let res = {
//     startAt: startDateTime,//.toISOString(),
//     endAt: endDateTime//.toISOString()
//   }

//   return res
// }